const apiUrls = require('../../constants/apiUrls');
const equipmentDetails = {
    key: 'equipmentDetails',
    apiUrl: apiUrls.EQUIPMENT_DETAIL_URL,
    method: 'GET',
    getApiUrl: (request) => {
        return `${apiUrls.EQUIPMENT_DETAIL_URL}?billingSystem=${request.billingSystem}&accountNumber=${request.accountNumber}&orderNumber=${request.workOrderNumber}`;
    },
    dependencies: [
        {
            key: 'orderDetails',
            requestProps: [
                {
                    path: [
                        'details', 'accountNumber'
                    ],
                    propName: 'accountNumber'
                }
            ]
        }, {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'billingSystem'
                    ],
                    propName: 'billingSystem'
                }
            ]
        }, {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'serviceOrderInfoV2', 'serviceOrderId'
                    ],
                    propName: 'workOrderNumber'
                }
            ]
        }
    ]
};

export default equipmentDetails;


// WEBPACK FOOTER //
// ./src/store/order-details-config/equipmentDetails.js